import { Leaf, Gauge, Route, Fuel } from "lucide-react";
import { AreaChart, Area, ResponsiveContainer, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";
import api from "@/lib/api";
import { PageHeader, useFetch, Spinner, StatCard } from "@/components/portal/ui";
import { Progress } from "@/components/ui/progress";

export default function SustainabilityOps() {
  const { data, loading } = useFetch(() => api.get("/sustainability").then((r) => r.data));
  if (loading) return <Spinner />;

  return (
    <div>
      <PageHeader title="Sustainability & Carbon" subtitle="Emissions, efficiency and utilisation reporting" />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <StatCard testid="sus-co2" label="Total CO₂" value={`${data.total_co2_tonnes} t`} icon={Leaf} accent="text-emerald-600" />
        <StatCard testid="sus-per-ship" label="CO₂ / Shipment" value={`${data.co2_per_shipment_kg} kg`} icon={Gauge} />
        <StatCard testid="sus-per-km" label="CO₂ / km" value={`${data.co2_per_km_g} g`} icon={Route} accent="text-blue-600" />
        <StatCard testid="sus-fuel" label="Fuel Consumed" value={`${data.fuel_total_l.toLocaleString()} L`} icon={Fuel} accent="text-orange-600" />
      </div>

      <div className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 rounded-xl border border-border bg-card p-6">
          <h2 className="font-heading font-bold mb-4">Carbon emissions trend (tonnes)</h2>
          <ResponsiveContainer width="100%" height={280}>
            <AreaChart data={data.trend}>
              <defs><linearGradient id="c" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#16A34A" stopOpacity={0.4} /><stop offset="100%" stopColor="#16A34A" stopOpacity={0} /></linearGradient></defs>
              <CartesianGrid strokeDasharray="3 3" opacity={0.2} />
              <XAxis dataKey="month" fontSize={12} /><YAxis fontSize={12} />
              <Tooltip /><Area type="monotone" dataKey="co2" stroke="#16A34A" fill="url(#c)" strokeWidth={2} />
            </AreaChart>
          </ResponsiveContainer>
        </div>
        <div className="rounded-xl border border-border bg-card p-6 space-y-5">
          <h2 className="font-heading font-bold">Efficiency</h2>
          {[
            { l: "Load Utilisation", v: data.load_utilization_pct, c: "text-emerald-600" },
            { l: "Route Efficiency", v: data.route_efficiency_pct, c: "text-blue-600" },
            { l: "Empty Kilometres", v: data.empty_km_pct, c: "text-orange-600" },
          ].map((m) => (
            <div key={m.l}>
              <div className="flex justify-between text-sm mb-1"><span>{m.l}</span><span className="font-semibold">{m.v}%</span></div>
              <Progress value={m.v} className="h-2" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
